import * as Sentry from '@sentry/browser';
import { parse, stringify } from 'qs';
import { setReferrerFromQueryParams } from 'src/components/ReferralBanner/ReferralBannerUtils';

import { initialize as initializeAnalytics } from 'src/services/analytics/analytics';
import { retrieveAndSetMerchantInfo } from 'src/services/growthapi';

export const extractUserTokenFromUrl = () => {
  const { userLinkToken, ...additionalParams } = parse(window.location.search, { ignoreQueryPrefix: true });

  function logUserLinkToken() {
    Sentry.addBreadcrumb({
      category: 'userLinkToken',
      message: 'Retrieved userLinkToken from the url',
      data: {
        href: window.location.href,
        pathname: window.location.pathname,
        userLinkToken,
      },
      level: Sentry.Severity.Info,
    });
  }

  try {
    if (userLinkToken) {
      logUserLinkToken();
    }

    window.history.replaceState({}, document.title, `${window.location.pathname}${stringify(additionalParams, { addQueryPrefix: true })}`);
  } catch (err) {
    Sentry.captureException(err);
  }

  return { userLinkToken: userLinkToken as string };
};

export const processUrlAndInitializeAnalytics = async () => {
  const { userLinkToken } = extractUserTokenFromUrl();
  if (userLinkToken) {
    await retrieveAndSetMerchantInfo(userLinkToken);
  }

  setReferrerFromQueryParams();

  await initializeAnalytics();
};
